/**
 * @fileoverview Image drop zone for the requirement creation form.
 * @module components/RequirementCreationView/RequirementImageUpload
 */
import { ReactComponent as UploadIcon } from "../../assets/icons/Cloud_Upload.svg";
import styles from "./index.module.css";

const RequirementImageUpload = ({
  imageRef,
  onDragEnter,
  onDragLeave,
  onDrop,
  tempImage,
  imageError,
  onChangeImage,
  t,
}) => (
  <div className={styles.imageContainer}>
    <label className={styles.label}>
      {t("components.requirementCreationModal.image")}
    </label>
    <div
      ref={imageRef}
      className={styles.dropFileInput}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      {tempImage ? (
        <img
          src={tempImage}
          alt={t("common.requirementImageAlt")}
          className={styles.uploadedImage}
        />
      ) : (
        <div className={styles.uploadContainer}>
          <UploadIcon className={styles.uploadIcon} />
          {imageError && (
            <span className={styles.errorMessage}>{imageError}</span>
          )}
          <span className={styles.uploadTitle}>{t("common.drag&drop")}</span>
          <span className={styles.uploadSubtitle}>
            {t("common.yourImage")}{" "}
            <span
              style={{ color: "#1D5AE8" }}
              className={styles.uploadSubtitle}
            >
              {t("common.browseFile")}
            </span>
          </span>
        </div>
      )}
      <input
        className={styles.imageInput}
        type="file"
        accept="image/*"
        onChange={onChangeImage}
        // onChange={(e) => handleChange("image", e.target.files[0])}
      />
    </div>
  </div>
);

export default RequirementImageUpload;
